import React, { FunctionComponent } from 'react';
import PageContentComponent from '..';
import { Background } from '../../../types/background';
import { ExternalLinkIcon } from '../../Icons';
import './styles.scss';

type ExternalLinksProps = {
  data: {
    background: Background;
    title: string;
    content: {
      _key: string;
      title: string;
      publishDate?: string | null;
      link: string;
    }[];
  };
}

const ExternalLinks: FunctionComponent<ExternalLinksProps> = ({ data }) => {
  return (
    <section className={`external-links ${data.background}`}>
      <div>
        <h2>{data.title}</h2>
        <div className='external-links-container'>
          {data.content.map(card => (
            <a
              key={card._key}
              className='science-card'
              href={card.link}
              rel='noopener noreferrer'
              target='_blank'
            >
              <h4>{card.title}</h4>
              {card.publishDate && (
                <span>{card.publishDate}</span>
              )}
              <ExternalLinkIcon size={18} />
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ExternalLinks;
